module.exports = __webpack_public_path__ + "img/shutterstock.39fd9db4.jpg";